import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import SpotlightImage from '../../assets/spotlight.png'

const SubAccount = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <img src={SpotlightImage} alt="" width="100%"/>
          </Grid>
          <Grid item xs={12}>
            <Typography
              component="h5"
              variant="h5"
              gutterBottom
              color="textPrimary">
              Parece que já nos vimos antes!
            </Typography>
            <Typography
              component="p"
              variant="body1"
              gutterBottom
              color="textPrimary">
              Seu CNPJ já foi cadastrado como PJ ou Fornecedor, deseja cadastrar uma subconta?
            </Typography>
            <Typography
              component="p"
              variant="caption"
              gutterBottom
              color="textPrimary">
              Ao clicar em enviar abaixo iremos criar uma nova conta de parceiro para você, utilizando os dados da sua empresa já cadastrados em nossa base, ao continuar você concorda com nossa política de privacidade e termos de uso.
            </Typography>
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default SubAccount;
